<template>
    <div class="page-space">
        <div class="wrapper ui">
            <h2>Manage Categories</h2>
            <div class="ui grid secondary segment">
                <div class="wide column">
                    <a href="/admin/category/create" class="green ui button sharp tiny basic"><i class="plus icon"></i>Create Category</a>
                    <br /><br />
                    <table class="ui small celled table">
                        <template v-if="categories">
                            <thead>
                            <tr>
                                <th>Actions</th>
                                <th>Category</th>
                                <th>Subcategory?</th>
                                <th></th>
                            </tr>
                            </thead>
                            <draggable @change="updateOrder" :list="categories" tag="tbody">
                                <tr v-for="category in categories" :key="category.id">
                                    <td style="width: 10em">
                                        <a :href="'/admin/category/' + category.id + '/edit'" class="ui mini button">Edit</a>
                                    </td>
                                    <td>
                                        {{ category.name }}
                                    </td>
                                    <td>{{ category.parent_id ? 'Yes' : 'No'}}</td>
                                    <td style="text-align: right; width: 5em; cursor: pointer"><i class="icon sort"></i></td>
                                </tr>
                            </draggable>
                        </template>
                        <template v-else>
                            <h3>No categories yet!</h3>
                        </template>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import draggable from 'vuedraggable'
    export default {
        components: {
            draggable,
        },
        data() {
            return {
                categories: window.adminOrderItems,
                orderURL: window.orderURL
            }
        },
        methods: {
            /**
             * Update order when done dragging
             * @param e
             */
            updateOrder : function(e)
            {
                var old = e.oldIndex,
                    now = e.newIndex,
                    data = this.categories;
                data.splice(now, 0, data.splice(old, 1)[0]);
                this.saveOrder();
            },

            /**
             * Save asset order when done dragging
             */
            saveOrder : function()
            {
                var self = this;
                $.ajax({
                    url: self.orderURL,
                    type: 'POST',
                    dataType: 'JSON',
                    data: {
                        items: self.categories
                    },
                    success: function(data) {
                        if (!data.success) {
                            alert(data.message);
                        }
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/category/index.vue